import SlugPageFrame from ".//slug-page-frame";
import { buildSlugDynamicCss } from "./slug-dynamic-styles";
import { getSerializedBuilderData, parseSerializedBuilderData } from "./slug-content-utils";

export default function SlugPageContent({ content }) {
    const serializedBuilderData = getSerializedBuilderData(content);
    const dynamicCss = buildSlugDynamicCss(parseSerializedBuilderData(content));

    return (
        <>
            {dynamicCss ? <style data-slug-dynamic-css>{dynamicCss}</style> : null}
            <SlugPageFrame serializedBuilderData={serializedBuilderData} />
        </>
    );
}